module.exports = __webpack_public_path__ + "img/ApplicationManager-dark.d5a43e5c.svg";